import { getCurrentEvent } from "core-integration/src/store/events/reducers";
import { getPlayerData } from "core-integration/src/store/player/reducers";
import { hiDPI } from "polished";
import { useEffect } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styled from "styled-components";
// Hero images
import heroImg1x from "../img/hero@1x.jpg";
import heroImg2x from "../img/hero@2x.jpg";
// Highlight images
import {
  default as homeFirst1x,
  default as homeSecond1x,
} from "../img/home/home-first@1x.jpg";
import homeFirst2x from "../img/home/home-first@2x.jpg";
import homeSecond2x from "../img/home/home-second@2x.jpg";
// import pitch from "../img/home/pitch.jpg";
// import pitch2x from "../img/home/pitch@2x.jpg";
import { getScoutProviders, IProviderWithTitle } from "../utils/rssContent";
import { Main, Wrapper } from "./Layout";
import Login from "./Login";
import ScoutProvider from "./scout/ScoutProvider";
import Status from "./status/Status";
import TriangleCard from "./TriangleCard";
import PageAd from "./PageAd";

const PageAdWrapper = styled.div`
  margin-top: ${({ theme }) => theme.space[5]};
`;

const HomeHero = styled.div`
  margin-left: ${({ theme }) => theme.space[2]};
  margin-right: ${({ theme }) => theme.space[2]};
  margin-bottom: 60px;
  padding-top: 270px;
  text-align: center;
  height: 0;
  position: relative;
  border-radius: ${({ theme }) => theme.radii[2]};
  background-image: url(${heroImg1x});
  background-size: cover;
  background-repeat: no-repeat;

  ${hiDPI(2)} {
    background-image: url(${heroImg2x});
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    margin-left: 0;
    margin-right: 0;
  }
`;

const Highlights = styled.div`
  margin: ${({ theme }) => theme.space[4]} ${({ theme }) => theme.space[2]};

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    display: flex;
    justify-content: space-between;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    margin-left: 0;
    margin-right: 0;
  }
`;

const HighlightsItem = styled.div`
  margin-bottom: ${({ theme }) => theme.space[4]};
  border-radius: ${({ theme }) => theme.radii[2]};

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    flex: 0 0 calc(50% - 1rem);
    margin-bottom: 0;
  }
`;

type Props = WithTranslation;

const Home = ({ t }: Props) => {
  const now = useSelector(getCurrentEvent);
  const player = useSelector(getPlayerData);

  const TrackFacebook = (): void => {
    const fbq = (window as any).fbq;
    if (fbq) {
      fbq("trackCustom", "FPLLanding");
    }
  };

  useEffect(() => {
    TrackFacebook();
  }, []);

  // Show the status page if have a team and the game has started
  if (now && player && player.entry) {
    return <Status />;
  }

  return (
    <Wrapper>
      <Main isWide={true}>
        <HomeHero />
        <Login />
        <PageAdWrapper>
          <PageAd />
        </PageAdWrapper>
        <Highlights>
          <HighlightsItem>
            <TriangleCard
              title={t("home.highlightsLeftTitle", "Pick your squad")}
              desc={t(
                "home.highlightsLeftDesc",
                "Use your budget of 100Mkr to pick a squad of 15 players from Allsvenskan.",
              )}
              mdSrc={homeFirst2x}
              smSrc={homeFirst1x}
            />
          </HighlightsItem>
          <HighlightsItem>
            <TriangleCard
              title={t("home.highlightsRightTitle", "Create & join leagues")}
              desc={t(
                "home.highlightsRightDesc",
                "Play against friends, family members, colleagues or your friends from the web in private leagues.",
              )}
              mdSrc={homeSecond2x}
              smSrc={homeSecond1x}
            />
          </HighlightsItem>
        </Highlights>
        {getScoutProviders(t).map((provider: IProviderWithTitle) => (
          <ScoutProvider
            key={provider.url}
            link={provider.link}
            url={provider.url}
            numberOfArticles={4}
            title={provider.title}
          />
        ))}
        {/* <Highlights>
            <TriangleCard
              reverse
              highlight
              title={t("home.highlightBottomTitle", "That's How Fantasy Works")}
              desc={t(
                "home.highlightBottomDesc",
                "In Allsvenskan Fantasy, it is not just about punching in the right starting eleven, you need to keep track of your formation, bench and maybe above all the budget. This is how it works!"
              )}
              mdSrc={pitch2x}
              smSrc={pitch}
              btnText={t("home.highlightBottomBtn", "Read more")}
              btnLink="https://www.allsvenskan.se/fantasy/sa-valjer-du-din-din-trupp"
            />
          </Highlights> */}
      </Main>
    </Wrapper>
  );
};

export default withTranslation()(Home);
